import { html } from 'fxjs/es';

export const makeBlankPlateHtml = () =>
  html`<div class="blank_plate" style="position: fixed; top: 0; right: 0; bottom: 0; left: 0"></div>`;
